"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'a',
    'button',
    'dd',
    'dt',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'li',
    'option',
    'p',
    'select',
    'table'
];
//# sourceMappingURL=UnnestableElements.js.map